import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import initialState, {
  fulfilledHandler,
  loadingHandler,
  rejectedHandler,
} from "./initialState";
import api from "../api";

export const GetAllLayananDropdown = createAsyncThunk(
  "layanan/GetAllLayananDropdown",
  async (data, thunkAPI) => {
    let response;
    try {
      response = await axios.get(`${api}master/layanan`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetAllLayanan = createAsyncThunk(
  "layanan/GetAllLayanan",
  async (data, thunkAPI) => {
    let response;
    try {
      response = await axios.get(`${api}master/layanan/all?${data.url}`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetSingleLayanan = createAsyncThunk(
  "layanan/GetSingleLayanan",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}master/layanan/get_by_id/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const CreateLayanan = createAsyncThunk(
  "layanan/CreateLayanan",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(
        `${api}master/layanan`,
        {
          kode: data.kode,
          nama: data.nama,
          deskripsi: data.deskripsi,
        },
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const EditLayanan = createAsyncThunk(
  "layanan/EditLayanan",
  async (data, thunkAPI) => {
    try {
      const response = await axios.put(
        `${api}master/layanan/${data.id}`,
        {
          kode: data.kode,
          nama: data.nama,
          deskripsi: data.deskripsi,
        },
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const DeleteLayanan = createAsyncThunk(
  "layanan/DeleteLayanan",
  async (data, thunkAPI) => {
    let listData;
    try {
      const responseDelete = await axios.delete(
        `${api}master/layanan/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );

      if (responseDelete.data.success) {
        listData = await axios.get(`${api}master/layanan/all?${data.url}`, {
          headers: {
            Authorization: data.token,
          },
        });

        return {
          delete: responseDelete.data,
          meta: listData.data.meta,
          items: listData.data.items,
        };
      }
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const layananSlice = createSlice({
  name: "layanan",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    // get all layanan
    builder.addCase(GetAllLayananDropdown.pending, loadingHandler);
    builder.addCase(GetAllLayananDropdown.fulfilled, fulfilledHandler);
    builder.addCase(GetAllLayananDropdown.rejected, rejectedHandler);
    // get all layanan
    builder.addCase(GetAllLayanan.pending, loadingHandler);
    builder.addCase(GetAllLayanan.fulfilled, fulfilledHandler);
    builder.addCase(GetAllLayanan.rejected, rejectedHandler);
    // get Single layanan
    builder.addCase(GetSingleLayanan.pending, loadingHandler);
    builder.addCase(GetSingleLayanan.fulfilled, fulfilledHandler);
    builder.addCase(GetSingleLayanan.rejected, rejectedHandler);
    // create layanan
    builder.addCase(CreateLayanan.pending, loadingHandler);
    builder.addCase(CreateLayanan.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isCreate: true });
    });
    builder.addCase(CreateLayanan.rejected, rejectedHandler);
    // edit layanan
    builder.addCase(EditLayanan.pending, loadingHandler);
    builder.addCase(EditLayanan.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isEdit: true });
    });
    builder.addCase(EditLayanan.rejected, rejectedHandler);
    // delete layanan
    builder.addCase(DeleteLayanan.pending, loadingHandler);
    builder.addCase(DeleteLayanan.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isError: true });
    });
    builder.addCase(DeleteLayanan.rejected, rejectedHandler);
  },
});

export const { reset } = layananSlice.actions;
export default layananSlice.reducer;
